import { Modal } from 'antd';
import { useState } from 'react';
import { connect } from 'react-redux';

import {
  Button,
  ButtonGroup,
  Checkbox,
  VStack,
} from '@frontend/legacy-components';

import UserGroupSelector from 'modules/common/smartComponents/userGroupSelector/UserGroupSelector';

import {
  superUserChangeUserGroup,
  superUserChangeUserGroupModal,
} from '../data/actions';
import { getIsSuperUserChangeUserGroupModalOpen } from '../data/reducer';

const connector = connect(
  (state) => ({
    isOpen: getIsSuperUserChangeUserGroupModalOpen(state),
  }),
  {
    closeModal: superUserChangeUserGroupModal.close,
    changeUserGroup: superUserChangeUserGroup.request,
  },
);

const SuperUserChangeUserGroupModal = ({
  closeModal,
  isOpen,
  changeUserGroup,
}) => {
  const [selectedUserGroup, setSelectedUserGroup] = useState(null);
  const [confirmed, setConfirmed] = useState(false);

  return (
    <Modal
      closable={true}
      destroyOnClose
      visible={isOpen}
      onCancel={closeModal}
      title="Change Organization"
      footer={null}
      width="576px"
    >
      <VStack spacing={3} align="stretch">
        <UserGroupSelector
          disabled={false}
          onChange={(userGroup) => setSelectedUserGroup(userGroup)}
          selectedUserGroup={selectedUserGroup}
          optionsDisabledFn={null}
        />
        {selectedUserGroup && (
          <Checkbox
            isChecked={confirmed}
            onChange={() => setConfirmed(!confirmed)}
          >
            I understand that I am changing my organization to&nbsp;
            <strong>{selectedUserGroup.label}</strong>
          </Checkbox>
        )}

        <ButtonGroup display="flex" size="md" justifyContent="flex-end">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() =>
              changeUserGroup({ userGroupId: selectedUserGroup.value })
            }
            isDisabled={!confirmed}
          >
            Change Organization
          </Button>
        </ButtonGroup>
      </VStack>
    </Modal>
  );
};

export default connector(SuperUserChangeUserGroupModal);
